import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import {LoadingLogoPortal} from "features/components/loading-logo";
import ThreadSearchResults from "features/pages/threads/search";
import {Icon} from "features/components/icon";
import {TextField} from "features/components/text-field";
import {__} from "services/i18n";
import Button from "features/components/button";
import Select from "features/components/select";
import {MOBILE_MEDIA_QUERY_THRESHOLD, THREADS_ORDER_BY, THREAD_TYPES} from "constants.js";
import {threadsSearchFilters, threadsSearchLoading} from "features/pages/threads/search/selectors";
import {setThreadsSearchFilters} from "features/pages/threads/search/reducer";
import {useMediaQuery} from "services/utils/utils";
import {historyObject} from "historyObject";
import {staticDataInterests} from "store/reducer/static/selectors";
import ThreadArchiveResults from "features/pages/threads/archive";
import ThreadHighlights from "features/pages/threads/highlights";
import ThreadLeaderboards from "features/pages/threads/leaderboards";
import ThreadFavorites from "features/pages/threads/favorite";
import {initialState as initialFilterState} from "./search/reducer";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: threadsSearchLoading(state),
    filters: threadsSearchFilters(state),
    categories: staticDataInterests(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    setThreadsSearchFilters
};

export const ThreadsPage = (props) => {
    const {loading, filters, categories} = props;
    const {setThreadsSearchFilters} = props;
    const setFilterValue = useCallback((key, value) => {
        setThreadsSearchFilters({
            [key]: value
        })
    }, [setThreadsSearchFilters]);

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);
    const [openFilters, setOpenFilters] = useState(false);
    const toggleOpenFilters = useCallback(() => {
        setOpenFilters(!openFilters);
    }, [openFilters, setOpenFilters]);

    const filtersRow = useCallback(() => {
        return <div className="row filters">
            <div className={"search"}>
                <Icon>search</Icon>
                <TextField type={"text"} value={filters.search} onChange={(val) => setFilterValue("search", val)} placeholder={__("threads.filters.search")} />
                {!!filters.search && <div className="reset" onClick={() => setFilterValue("search", "")}><Icon>close</Icon></div>}
            </div>
            <div className={`choices ${openFilters ? "mobile-show" : "mobile-hide"}`}>
                <Select
                    value={filters.categories}
                    onChange={(val) => setFilterValue("categories", val)}
                    multiple={true}
                    values={categories}
                    placeholder={__("threads.filters.categories")}
                    noSelectionString={__("common.all.female")}
                />
                <Select
                    value={filters.type}
                    onChange={(val) => setFilterValue("type", val)}
                    multiple={false}
                    values={[   {key: "all", value: "threads.filters.types.all"},
                                {key: THREAD_TYPES.thread, value: "threads.filters.types.discussion"},
                                {key: THREAD_TYPES.request, value: "threads.filters.types.request"}
                        ]}
                    placeholder={__("threads.filters.type")}
                    noSelectionString={__("")}
                />
                <Select
                    value={filters.order_by}
                    onChange={(val) => setFilterValue("order_by", val)}
                    values={THREADS_ORDER_BY}
                    placeholder={__("common.order-by.placeholder")}
                    noSelectionString={__("threads.filters.order-by.default")}
                />
                <Button title={__("buttons.new-thread")} type={"accent"} icon={"add-circle"} onClick={() => historyObject.push("/threads/new")} />
            </div>
            {isMobile && <div className="show-filters">
                <Button title={__("buttons.show-filters")} onClick={toggleOpenFilters} type={"clear"} icon={openFilters ? "arrow-dropdown-up" : "arrow-dropdown-down"} />
            </div>}
        </div>
    }, [categories, filters.categories, filters.order_by, filters.search, filters.type, isMobile, openFilters, setFilterValue, toggleOpenFilters]);

    const renderTopResults = useMemo(() => {
        if(JSON.stringify(filters) !== JSON.stringify(initialFilterState.filters)) return null;
        return <>
            <ThreadHighlights />
            <ThreadFavorites />
        </>
    }, [filters]);

    return <LoggedInLayout type={"light"}
                           className={"threads-page"}
                           breadcrumbs={[{title: "common.home-breadcrumb", link:"/"}, {title: "threads.breadcrumb"}]}
    >
        {loading && <LoadingLogoPortal />}
        {filtersRow()}
        {renderTopResults}
        <div className={"sidebar-wrapper"}>
            <div className={"content"}>
                <ThreadSearchResults />
                <ThreadArchiveResults />
            </div>
            <div className={"sidebar"}>
                <ThreadLeaderboards />
            </div>
        </div>
    </LoggedInLayout>;
};

export default connect(mapStateToProps, mapDispatchToProps)(ThreadsPage);